export const container = ({ width, slides, translate, transitionDuration }) => ({
    width: width * slides.length,
    display: 'flex',
    transform: `translateX(${translate}px)`,
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s`,
    willChange: 'transform',

    paddingBottom: '1rem',

    tablet: {
        paddingBottom: '3rem',
    },

    tabletLarge: {
        paddingBottom: 0,
    },
});

export const navigationContainer = () => ({
    top: '33.333%',
});

export const navigationButton = () => ({
    right: '1.25rem',

    tablet: {
        right: 'initial',
    },
});

export const stepNavigationContainer = () => ({
    display: 'none',

    tablet: {
        display: 'inline-flex',
    },
});
